import { inject, Injectable } from '@angular/core';
import { ToastrFactoryService } from '../services/toastr-factory.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export default class getFromClipboardUtils {
  protected toastrFactory = inject(ToastrFactoryService);
  protected translate = inject(TranslateService);

  async canReadFromClipboard(): Promise<boolean> {
    try {
      const test = await navigator.clipboard.readText();
      return true;
    } catch (e: any) {
      console.log(e);
      return false;
    }
  }
}
